import numeral from 'numeral';

export function formatCount(count) {
  if (count >= 1000) {
    return numeral(count).format('0.0a');
  }
  return count.toString();
}

export function toPascalCase(camelCased) {
  if (!camelCased) {
    return camelCased;
  }

  return camelCased.charAt(0).toUpperCase() + camelCased.slice(1);
}

export function toInitials(name) {
  if (!name) {
    return '';
  }

  const nameParts = name.split(' ').filter(n => n && n.length > 0);
  if (nameParts.length === 1) {
    return nameParts[0][0];
  }

  if (nameParts.length >= 2) {
    return nameParts[0][0] + nameParts[1][0];
  }

  return '';
}
